import type { DrawerTitleProps } from './types';

import { Typography } from '../../atoms/Typography';
import { Icon } from '../../atoms/icons';

const DrawerTitle = ({ drawerTitle, onDrawerClose }: DrawerTitleProps) => (
  <div className={'flex justify-between w-full h-[60px] px-6 items-center'}>
    <Typography fontFace={'BodyRegularLg'} className={'text-gray-900'}>
      {drawerTitle}
    </Typography>
    <div
      className={
        'flex p-1 rounded-lg border border-[#D2D6DB] shadow-sm cursor-pointer'
      }
      onClick={onDrawerClose}
    >
      <Icon iconName={'iconX'} width={16} height={16} />
    </div>
  </div>
);

export { DrawerTitle };
